/**
 * Ecran d'attente partage.
 *
 * Ce composant vivait dans App.jsx, et les deux gardes de routes —
 * ProtectedRoute et AdminRoute — avaient chacun le leur, habille de classes
 * CSS qui ne sont pas chargees au moment ou il s'affiche :
 * `.auth-loading` est declaree dans pages/auth/auth.css et `.adm-route-loading`
 * dans components/admin/AdminLayout.css, deux feuilles qui partent avec des
 * modules charges a la demande. Un visiteur qui ouvre directement /profile ou
 * /admin voyait donc un <div> vide pendant la verification de sa session :
 * l'indicateur existait dans le code et n'existait pas a l'ecran.
 *
 * Les styles sont ecrits en ligne pour cette raison precise. Ils ne peuvent
 * pas se retrouver dans une feuille absente. Seule l'animation `spin` vient
 * de App.css, qui part avec l'entree du site et est donc toujours la.
 */
export default function PageLoader({ dark = false }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: dark ? '#0A0F1E' : 'var(--bg-primary)',
      }}
    >
      <div
        style={{
          width: 36, height: 36,
          border: `3px solid ${dark ? 'rgba(255,255,255,0.1)' : 'var(--border)'}`,
          borderTopColor: '#003DA5',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      {/* Un cercle qui tourne ne dit rien a un lecteur d'ecran. */}
      <span style={{
        position: 'absolute', width: 1, height: 1, padding: 0, margin: -1,
        overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0,
      }}>
        Chargement
      </span>
    </div>
  )
}
